import TermsOfUseVanModal from './TermsOfUseVanModal';

export default TermsOfUseVanModal;
